"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixinNativeETHWalletInfo = MixinNativeETHWalletInfo;
exports.MixinNativeETHWallet = MixinNativeETHWallet;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const utils_js_1 = require("ethers/lib/utils.js");
const Isolation = __importStar(require("./crypto/isolation"));
const ethereum_1 = __importDefault(require("./crypto/isolation/adapters/ethereum"));
function MixinNativeETHWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeETHWalletInfo extends Base {
        constructor() {
            super(...arguments);
            this._supportsETHInfo = true;
            this._chainId = 1;
        }
        ethSupportsNetwork() {
            return __awaiter(this, void 0, void 0, function* () {
                return true;
            });
        }
        ethSupportsSecureTransfer() {
            return __awaiter(this, void 0, void 0, function* () {
                return false;
            });
        }
        ethSupportsNativeShapeShift() {
            return false;
        }
        ethSupportsEIP1559() {
            return __awaiter(this, void 0, void 0, function* () {
                return true;
            });
        }
        ethGetAccountPaths(msg) {
            const slip44 = core.slip44ByCoin(msg.coin);
            if (slip44 === undefined)
                return [];
            return [
                {
                    addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0],
                    hardenedPath: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx],
                    relPath: [0, 0],
                    description: "Native",
                },
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ethNextAccountPath(msg) {
            // Only support one account for now (like portis).
            // the ethers library supports paths so it shouldnt be too hard if we decide multiple accounts are needed
            return undefined;
        }
    };
}
function MixinNativeETHWallet(Base) {
    var _MixinNativeETHWallet_ethSigner, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeETHWallet extends Base {
            constructor() {
                super(...arguments);
                this._supportsETH = true;
                this._supportsAvalanche = true;
                this._supportsOptimism = true;
                this._supportsBSC = true;
                this._supportsPolygon = true;
                this._supportsGnosis = true;
                this._supportsArbitrum = true;
                this._supportsArbitrumNova = true;
                this._supportsBase = true;
                this._supportsEthSwitchChain = false;
                _MixinNativeETHWallet_ethSigner.set(this, void 0);
            }
            ethInitializeWallet(masterKey) {
                return __awaiter(this, void 0, void 0, function* () {
                    const nodeAdapter = yield Isolation.Adapters.BIP32.create(masterKey);
                    __classPrivateFieldSet(this, _MixinNativeETHWallet_ethSigner, new ethereum_1.default(nodeAdapter), "f");
                });
            }
            ethWipe() {
                __classPrivateFieldSet(this, _MixinNativeETHWallet_ethSigner, undefined, "f");
            }
            ethGetAddress(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (msg.addressNList.length < 5) {
                        throw new Error(`path not supported length: ${msg.addressNList.length}`);
                    }
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), () => {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        return __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList);
                    });
                });
            }
            ethSignTx(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), () => __awaiter(this, void 0, void 0, function* () {
                        const utx = {
                            to: msg.to,
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            from: yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList),
                            nonce: msg.nonce,
                            gasLimit: msg.gasLimit,
                            data: msg.data,
                            value: msg.value,
                            chainId: msg.chainId,
                        };
                        const result = msg.maxFeePerGas
                            ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTransaction(Object.assign(Object.assign({}, utx), { maxFeePerGas: msg.maxFeePerGas, maxPriorityFeePerGas: msg.maxPriorityFeePerGas, type: core.ETHTransactionType.ETH_TX_TYPE_EIP_1559 }), msg.addressNList)
                            : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTransaction(Object.assign(Object.assign({}, utx), { gasPrice: msg.gasPrice, type: core.ETHTransactionType.ETH_TX_TYPE_LEGACY }), msg.addressNList);
                        const decoded = (0, utils_js_1.parseTransaction)(result);
                        return {
                            v: core.mustBeDefined(decoded.v),
                            r: core.mustBeDefined(decoded.r),
                            s: core.mustBeDefined(decoded.s),
                            serialized: result,
                        };
                    }));
                });
            }
            ethSignMessage(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), () => __awaiter(this, void 0, void 0, function* () {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const result = yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signMessage(msg.message, msg.addressNList);
                        return {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            address: yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList),
                            signature: result,
                        };
                    }));
                });
            }
            ethSignTypedData(msg) {
                return __awaiter(this, void 0, void 0, function* () {
                    return this.needsMnemonic(!!__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), () => __awaiter(this, void 0, void 0, function* () {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        return yield __classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTypedData(msg.typedData, msg.addressNList);
                    }));
                });
            }
            ethVerifyMessage(_b) {
                return __awaiter(this, arguments, void 0, function* ({ address, message, signature }) {
                    if (!signature.startsWith("0x"))
                        signature = `0x${signature}`;
                    const digest = (0, utils_js_1.keccak256)(core.buildMessage(message));
                    return (0, utils_js_1.recoverAddress)(digest, signature) === address;
                });
            }
        },
        _MixinNativeETHWallet_ethSigner = new WeakMap(),
        _a;
}
//# sourceMappingURL=ethereum.js.map